import React from 'react';
import styled from 'styled-components';
import { halfSpin, comeInOut } from 'styles/animations';
import useUniqueId from 'hooks/useUniqueId';
var SparkleWrapper = styled.span.withConfig({
  displayName: "Sparkle__SparkleWrapper",
  componentId: "sc-1t2tjz1-0"
})(["position:absolute;display:block;z-index:", ";@media (prefers-reduced-motion:no-preference){animation:", " 700ms forwards;}"], function (p) {
  return p.style.zIndex;
}, comeInOut);
var SparkleSvg = styled.svg.withConfig({
  displayName: "Sparkle__SparkleSvg",
  componentId: "sc-1t2tjz1-1"
})(["display:block;filter:url(#", ");@media (prefers-reduced-motion:no-preference){animation:", " 1000ms linear;}"], function (p) {
  return p.shadowId;
}, halfSpin);
var Sparkle = function Sparkle(_ref) {
  var path = _ref.path,
    size = _ref.size,
    color = _ref.color,
    style = _ref.style;
  var shadowId = useUniqueId('shadow');
  return /*#__PURE__*/React.createElement(SparkleWrapper, {
    style: style
  }, /*#__PURE__*/React.createElement(SparkleSvg, {
    shadowId: shadowId,
    width: size,
    height: size,
    viewBox: "0 0 68 68",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: path,
    fill: color
  }), /*#__PURE__*/React.createElement("svg", {
    height: "0",
    width: "0"
  }, /*#__PURE__*/React.createElement("filter", {
    id: shadowId,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: "1",
    dy: "1",
    stdDeviation: "2",
    floodOpacity: "0.3"
  })))));
};
export default Sparkle;